import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
import LoadingSpinner from "../components/LoadingSpinner";
import InfiniteScroll from "../components/InfiniteScroll";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";

const PAGE_SIZE = 8;

const Buyers = () => {
  const fetchBuyers = useCallback(async (page) => {
    const params = new URLSearchParams();
    params.append("type", "P");
    params.append("page", page);
    params.append("page_size", String(PAGE_SIZE));
    return apiClient.get(`/register/?${params.toString()}`);
  }, []);

  const { data: buyers, loading, hasMore, loadMore } = useInfiniteScroll(
    fetchBuyers,
    [],
    PAGE_SIZE,
  );

  const showInitialSpinner = loading && buyers.length === 0;

  return (
    <div className="px-2">
      <h2 className="mb-3" style={{ color: "#000000e6" }}>
        Buyers
      </h2>
      {showInitialSpinner ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingSpinner color="#FF3E1F" />
        </div>
      ) : buyers.length === 0 ? (
        <p className="text-muted">No buyers found.</p>
      ) : (
        <InfiniteScroll
          onLoadMore={loadMore}
          hasMore={hasMore}
          loading={loading}
          loader={<LoadingSpinner color="#FF3E1F" />}
        >
          <ul className="p-0">
            {buyers.map((buyer) => (
              <li
                key={buyer.id}
                className="d-flex gap-md-5 gap-3 flex-wrap flex-md-nowrap shadow align-items-center p-4 rounded-3 mb-3"
                style={{ backgroundColor: "#fff" }}
              >
                <div>
                  <h5 className="fw-bold ">Buyers Name</h5>
                  <p className="mb-0">{buyer.full_name}</p>
                </div>
                <div>
                  <h5 className="fw-bold ">Email</h5>
                  <p className="mb-0">{buyer.email}</p>
                </div>
                <Link
                  to={`/admin/user-detail/?id=${buyer?.id}`}
                  state={{ from: "/admin/buyers" }}
                  className="btn grey-btn rounded-3 ms-auto "
                >
                  Show More
                </Link>
              </li>
            ))}
          </ul>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default Buyers;
